import React, { useEffect, useState } from 'react';
import { ApiRequest } from "GlobalFunctions";
import OrdersSummary from './components/OrdersSummary';
import SalesBySeller from './components/SalesBySeller';
import SalesBySupplier from './components/SalesBySupplier';
import Box from "elements/Box";
import DateRange from 'elements/DateRange';
import moment from 'moment';

const OrdersDashboard = (props: any) => {
  const [summary, setSummary] = useState<any>({});
  const [salesBySeller, setSalesBySeller] = useState<any[]>([]);
  const [salesBySupplier, setSalesBySupplier] = useState<any[]>([]);
  const [formValues, setFormValues] = useState<any>({
    date: {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD")
    }
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        await ApiRequest({
          url: '/dashboard/getOrdersDashboard',
          method: 'get',
          headers: {
            'ltkn': localStorage.getItem('ltkn')
          },
          query: formValues,
          setResponse: (response: any) => {
            setSummary(response.summary);
            setSalesBySeller(response.salesBySeller);
            setSalesBySupplier(response.salesBySupplier);
          }
        });
      } catch (error) {
        console.error('Error fetching orders dashboard data:', error);
      }
    };

    fetchData();
  }, [formValues]);

  return (
    <div id="Dashboard" className="ModuleContainer">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h1>Pedidos</h1>
            <DateRange
              className="filters_datePicker"
              label="Date range"
              variant="outlined"
              fullWidth
              value={{
                startDate: formValues.date?.startDate || null,
                endDate: formValues.date?.endDate || null,
              }}
              format="MMMM DD, yyyy"
              onChange={(e: any) => {
                if (e.startDate && e.endDate) {
                  const startDate = moment(e.startDate).format("YYYY-MM-DD");
                  const endDate = moment(e.endDate).format("YYYY-MM-DD");

                  setFormValues({
                    ...formValues,
                    date: { startDate, endDate },
                  });
                }
              }}
              variantDatePicker="side-by-side"
            />
          </div>
          <div className="boxContainerActions">
          </div>
        </div>

        <div id="DashboardIn">
          <OrdersSummary summary={summary} />
          
            <div className="dashboard_row">
                <Box title="Ventas por Vendedor">
                <SalesBySeller salesBySeller={salesBySeller} />
                </Box>
            </div>
            <div className="dashboard_row">
                <Box title="Ventas por Proveedor">
                    <SalesBySupplier salesBySupplier={salesBySupplier} />
                </Box>
            </div>
        </div>
      </div>
    </div>
  );
};

export default OrdersDashboard;